/*
 * Constants.
 */

import {parseQueryString} from '../../../libs/shared/helpers/src/browser/urlHelpers';

export enum CallToActionTypesEnum {
  AUTOJOIN = 'autojoin',
  REQUEST_INVITE = 'request_invite',
  TRY_FRONT = 'try_front',
}

/*
 * Helpers.
 */

export function computeCallToActionFromQueryParams() {
  // eslint-disable-next-line no-undef
  const queryParams = parseQueryString(window.location.search);
  const {cta} = queryParams;

  switch (cta) {
    case CallToActionTypesEnum.REQUEST_INVITE:
      return CallToActionTypesEnum.REQUEST_INVITE;
    default:
      return CallToActionTypesEnum.TRY_FRONT;
  }
}

export function computeInviterNameFromQueryParams() {
  // eslint-disable-next-line no-undef
  const queryParams = parseQueryString(window.location.search);
  return queryParams.inviter_name;
}
